<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
   import Vue from 'vue'
// This variable will hold the reference to
// document's click handler
Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});
    
   export default {
      page: {
         title: "Add Consultation",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const current_date = moment().format("YYYY-MM-DD");
         const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");         
         const week_date = moment().add(2,'days').format("YYYY-MM-DD");
         return {
            title: "Add Consultation",
            items: [
               {
                  text: "Consultation",
                  href: "/consultations",
               },
               {
                  text: "Add Consultation",
                  active: true,
               },        
            ],

            consultation: {
               booking_date: current_date,
               patient_id: '',
               doctor_id: '',
               consultation_type: '',
               doctor_session_id: '',
               day_id: '',
               start_time: '',
               end_time: '',
               token: '',
               consultation_for:'',
               consultation_through: '',
               clinic_id: '',

               video_slot: '',
               clinic_slot: '',
               home_slot: '',

               payment_type: 'Cash',
               payment_id: '',
               amount: '',
            },
            print: 0,
            patients: [],
            patient_visible: false,
            patient_keyword: '',
                        patient_id: '',
            
                        members: [],
            member_visible: false,
            member_keyword: '',
            member_id: '',

            clinics:[],
            doctors: [],
            doctor_visible: false,
            doctor_keyword: '',
            doctor_id: '',

            clinic_schedules: [],
            clinic_slots: [],

            home_schedules: [],
            home_slots: [],

            video_schedules: [],
            video_slots: [],

            video_charge: '',
            home_charge: '',
            clinic_charge: '',

            video_fee: '',
            home_fee: '',
            clinic_fee: '',
            convenience_fee: '',
            video_convenience_fee: '',
            home_convenience_fee: '',
            clinic_convenience_fee: '',
            total_amount: '',
            consultation_fee: '',
            commision:'',
            
            no_days:'',

            errors: {},

            now: datetime_now,
            today: current_date,
            week: week_date,

            loading: false,
            video_on_leave: false,
            home_on_leave: false,
            clinic_on_leave: false,

            external_patient_id: '',
            scheduleLoading: false,
            autoTokenLoading: false,

         };
      },
      computed: {
         isClinicConsultation() {
            return Number(this.consultation.consultation_type) === 3
               || Number(this.consultation.consultation_through) === 2;
         },
         showClinicPaymentDetails() {
            return this.isClinicConsultation
               && this.patient_id
               && this.consultation.doctor_id
               && this.consultation.booking_date
               && this.consultation.clinic_id;
         },
         isBookingInProgress() {
            return this.loading || this.autoTokenLoading;
         },
      },
      mounted() {
    
      },
      created() {
         this.setPatientId();
      },

      methods: {
      onClickOutside() {
         //console.log("clicked outside");
         if(!this.patient_id){
            this.patient_keyword = '';
            this.patient_visible = false;
         }
       
      },
      setPatientId() {
            if (this.$route.params.id) {
               this.patient_keyword= this.$route.params.name;
               this.patient_id= this.$route.params.id;
               this.fetchPatients();
            }
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchDoctors() {

            if(this.consultation.consultation_through==1){
               let url = "api/admin/consultations/getdoctors?keyword=" + this.doctor_keyword;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.doctors = responseData.doctors;
                     this.doctor_visible = true;

                      this.justOpened = true;

                     // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.doctorInput?.focus();
                     });

                     // Reset the outside click block after a short delay
                     setTimeout(() => {
                        this.justOpened = false;
                     }, 300);
                     this.checkDoctor();
                     
                  })
                  .catch((err) => console.log(err));
            }else{
               let url = "api/admin/consultations/getClinicDoctors?clinic_id=" + this.consultation.clinic_id + "&keyword=" + this.doctor_keyword;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.doctors = responseData.doctors;
                     this.doctor_visible = true;
                      this.justOpened = true;

                     // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.doctorInput?.focus();
                     });

                     // Reset the outside click block after a short delay
                     setTimeout(() => {
                        this.justOpened = false;
                     }, 300);
                     this.checkDoctor();
                  })
                  .catch((err) => console.log(err));
            }
         },
         
         fetchMembers() {  
            let url = "api/admin/consultations/getMembers?patient_id=" + this.patient_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.members = responseData.members;
                  this.member_visible = true;
                  
               })
               .catch((err) => console.log(err));
         },
         fetchClinics(type) {
              
              let url = "api/admin/tv_show/getClinics?type=" + type;        
              this.getToken();
              this.$axios
                 .get(url, { headers: { Authorization: "Bearer " + this.token } })
                 .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.clinics = responseData.clinics;
                 })
                 .catch((err) => console.log(err));
           },
         clearThrough() {

            if(this.consultation.consultation_through == 2) {
               this.consultation.type = 'clinic';
               this.fetchClinics(1);
            } else {
               this.consultation.type = '';
               this.fetchDoctors();
            }
            this.doctor_id = '';
            this.consultation.doctor_id = '';
            this.consultation.clinic_id = '';
            this.consultation.booking_date = this.today;            

            this.consultation.video_slot_id = null;
            this.consultation.clinic_slot_id = null;
            this.consultation.home_slot_id = null;
            this.closeDoctorSearch();
         },
         clearThrough1() {
            this.consultation.booking_date = this.today;            
            this.consultation.video_slot_id = null;
            this.consultation.clinic_slot_id = null;
            this.consultation.home_slot_id = null;
            this.closeDoctorSearch();
            // this.fetchDoctorDetails();
         },
         fetchDoctorDetails() { 
            let url = "api/admin/doctors/details?doctor_id=" + this.consultation.doctor_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.no_days = responseData.doctor.no_days_booking;
                  this.week = moment().add(this.no_days, 'days').format("YYYY-MM-DD");
               })
               .catch((err) => console.log(err));
            
         },
         fetchSchedules() { 
            this.clearSlots();
            this.video_on_leave = false;
            this.home_on_leave = false;
            if(this.consultation.doctor_id && this.consultation.booking_date) {
               let url = "api/admin/consultations/getSchedulesNew?doctor_id=" + this.consultation.doctor_id + "&date=" + this.consultation.booking_date;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);

                     // this.clinic_schedules = responseData.clinic_schedules;
                     // this.clinic_slots = responseData.clinic_slots[0];

                     const leaves = responseData.leaves || [];
                     this.video_on_leave = leaves.some(
                        (leave) => leave.date === this.consultation.booking_date && leave.consultation_type == 1 && leave.leave == 1
                     );
                     this.home_on_leave = leaves.some(
                        (leave) => leave.date === this.consultation.booking_date && leave.consultation_type == 2 && leave.leave == 1
                     );

                     this.home_schedules = responseData.home_schedules;
                     this.home_slots = responseData.home_slots[0] || [];

                     this.video_schedules = responseData.video_schedules;
                     this.video_slots = responseData.video_slots[0] || [];

                     this.video_charge = responseData.video_charge;
                     this.home_charge = responseData.home_charge;
                     // this.clinic_charge = responseData.clinic_charge;

                     this.video_convenience_fee = responseData.doctor.convenience_fee;
                     this.video_fee = responseData.doctor.video_fee;
                     this.commision = responseData.doctor.commision;
                     this.home_convenience_fee = responseData.doctor.home_convenience_fee;
                     this.home_fee = responseData.doctor.home_fee;

                     // if booking date is current date, display time slots only after the current time starts here
                     // var now_plus_one = moment().add(1,'hours').format("YYYY-MM-DD HH:mm:ss");
                     var now_plus_five = moment().add(5,'minutes').format("YYYY-MM-DD HH:mm:ss");


                     if(this.consultation.booking_date==this.today) {
                        for(var i=0; i<this.video_slots.length; i++) {
                           var start_time = this.consultation.booking_date + " " + this.video_slots[i].start;
                           if(start_time <= now_plus_five) {
                              this.video_slots[i].dnone = true;
                           }
                        }

                        for(i=0; i<this.home_slots.length; i++) {
                           start_time = this.consultation.booking_date + " " + this.home_slots[i].start;
                           if(start_time <= now_plus_five) {
                              this.home_slots[i].dnone = true;
                           }
                        }

                        for(i=0; i<this.clinic_slots.length; i++) {
                           start_time = this.consultation.booking_date + " " + this.clinic_slots[i].start;
                           if(start_time <= now_plus_five) {
                              this.clinic_slots[i].dnone = true;
                           }
                        }
                     } // ends here

                     console.log(this.video_slots);
                     
                  })
                  .catch((err) => console.log(err));
            } if(this.consultation.doctor_id && this.consultation.booking_date && this.consultation.consultation_through == 1) {

               let url = "api/admin/consultations/doctor_clinics?doctor_id=" +this.consultation.doctor_id;        
              this.getToken();
              this.$axios
                 .get(url, { headers: { Authorization: "Bearer " + this.token } })
                 .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.clinics = responseData.clinics;
                 })
                 .catch((err) => console.log(err));
            }
            this.fetchClinicSchedule();
            
         },
         fetchClinicSchedule() { 
            // this.clearSlots();
            if(this.consultation.doctor_id && this.consultation.booking_date && this.consultation.clinic_id) {
               this.clinic_on_leave = false;
               this.scheduleLoading = true;
               this.consultation.day_id = '';
               let url = "api/admin/consultations/getClinicScheduleNew?doctor_id=" + this.consultation.doctor_id + "&date=" + this.consultation.booking_date + "&clinic_id=" + this.consultation.clinic_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     // console.log(responseData);

                     const leaves = responseData.leaves || [];
                     this.clinic_on_leave = leaves.some(
                        (leave) => leave.date === this.consultation.booking_date && leave.leave == 1 &&
                           (leave.consultation_type == null || leave.consultation_type == 3)
                     );

                     this.clinic_schedules = responseData.clinic_schedules;
                     this.clinic_slots = responseData.clinic_slots[0] || [];
                     if (this.clinic_schedules && this.clinic_schedules[0] && this.clinic_schedules[0][0]) {
                        this.consultation.day_id = this.clinic_schedules[0][0].day_id;
                     }
                     // console.log(this.clinic_slots);
                     this.clinic_charge = responseData.clinic_charge;
                     this.clinic_fee = responseData.clinic_fee;
                     this.clinic_convenience_fee = responseData.convenience_fee;

                     this.setCharge();

                     // if booking date is current date, display time slots only after the current time starts here
                     var now_plus_one1 = moment().format("YYYY-MM-DD HH:mm:ss");

                     if(this.consultation.booking_date==this.today) {

                        for(var j=0; j<this.clinic_slots.length; j++) {
                           var start_time1 = this.consultation.booking_date + " " + this.clinic_slots[j].start;
                           if(start_time1 <= now_plus_one1) {
                              this.clinic_slots[j].dnone = true;
                           }
                        }
                     } // ends here
                  })
                  .catch((err) => console.log(err))
                  .finally(() => {
                     this.scheduleLoading = false;
                  });
            } else {
               this.clinic_on_leave = false;
               this.clinic_slots = [];
               this.consultation.day_id = '';
               this.scheduleLoading = false;
            }
            
         },

       fetchPatients() { 
            let url = "api/admin/pharmacy/orders/getpatients?keyword=" + this.patient_keyword;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.patients = responseData.patients;
                  if (this.$route.params.id) {
                     this.setPatient();
                  }else{
                     this.patient_visible = true;
                     this.justOpened = true;

                     // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.patientInput?.focus();
                     });

                     // Reset the outside click block after a short delay
                     setTimeout(() => {
                        this.justOpened = false;
                     }, 300);
                  }
               })
               .catch((err) => console.log(err));
            
         },

         closePatientSearch() {
            this.patient_visible = false;
            this.patient_keyword = '';
            this.patient_id = '';
            this.external_patient_id = '';
         },

         fetchExternalPatientId() {
            if (!this.patient_id || !this.consultation.clinic_id) {
               this.external_patient_id = '';
               return;
            }

            let url = "api/admin/consultations/patient_external_id?patient_id="
               + this.patient_id
               + "&clinic_id="
               + this.consultation.clinic_id;

            if (this.consultation.consultation_for) {
               url += "&member_id=" + this.consultation.consultation_for;
            }

            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if (res.data.status && res.data.data && res.data.data.has_external_patient_id) {
                     this.external_patient_id = res.data.data.external_patient_id || '';
                  } else {
                     this.external_patient_id = '';
                  }
               })
               .catch(() => {});
         },

         getClinicIdForBooking() {
            if (Number(this.consultation.consultation_through) === 2) {
               return this.consultation.clinic_id;
            }
            if (Number(this.consultation.consultation_type) === 3) {
               return this.consultation.clinic_id;
            }
            return null;
         },

         shouldUsePrescriptionTokenPrint() {
            return Number(this.consultation.consultation_type) === 3
               || Number(this.consultation.consultation_through) === 2;
         },

         getPrintTokenUrl(bookingId) {
            if (this.shouldUsePrescriptionTokenPrint()) {
               return "api/admin/downloadPrescriptionToken?booking_id=" + bookingId;
            }
            return "api/downloadToken?booking_id=" + bookingId;
         },

         printBookingToken(bookingId) {
            const url = this.getPrintTokenUrl(bookingId);
            this.getToken();

            return this.$axios
               .get(url, {
                  headers: { Authorization: "Bearer " + this.token },
                  responseType: "blob"
               })
               .then(res => {
                  const blob = new Blob([res.data], { type: "application/pdf" });
                  const blobUrl = URL.createObjectURL(blob);
                  const printWindow = window.open(blobUrl, '_blank');

                  printWindow.onload = () => {
                     printWindow.focus();
                     printWindow.print();
                  };

                  setTimeout(() => {
                     URL.revokeObjectURL(blobUrl);
                  }, 5000);
               })
               .catch(error => {
                  console.error("Error printing PDF:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     try {
                        const errorData = JSON.parse(text);
                        const errorMessage = errorData.message;
                        if (errorMessage) {
                           this.errors = errorMessage;
                        } else {
                           this.$swal("", "Failed to load PDF for printing", "error");
                        }
                     } catch (e) {
                        this.$swal("", "Failed to load PDF for printing", "error");
                     }
                  };
                  if (error.response && error.response.data) {
                     reader.readAsText(error.response.data);
                  } else {
                     this.$swal("", "Failed to load PDF for printing", "error");
                  }
               });
         },

         setPatient() {
            if (this.$route.params.id) {
               this.patient_id = this.$route.params.id;
               this.patient_keyword = this.$route.params.name;
               this.patient_visible = false;
            }else{
            this.patient_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.patient_visible = false;
            }
            this.external_patient_id = '';
            this.fetchMembers();
            this.fetchExternalPatientId();

         },

         closeDoctorSearch() {
            this.doctor_visible = false;
            this.doctor_keyword = '';
            this.doctor_id = '';
            this.consultation.amount = '';
            this.convenience_fee = '';
            this.total_amount = '';
            this.clinic_fee = ''
            this.home_fee = '';
            this.consultation.video_slot_id = null;
            this.consultation.clinic_slot_id = null;
            this.consultation.home_slot_id = null
            this.video_slots = [];
            this.clinic_slots = [];
            this.home_slots = [];
            this.video_on_leave = false;
            this.home_on_leave = false;
            this.clinic_on_leave = false;
            this.consultation.day_id = '';

         },

         prepareConsultationSubmit() {
            if (this.patient_visible) {
               this.patient_id = '';
            }
            if (this.doctor_visible) {
               this.doctor_id = '';
            }
            this.getToken();
         },

         handleBookingSuccess(response, shouldPrint) {
            if (response.data.status) {
               this.$swal("", response.data.message, "success");
               if (response.status == 200) {
                  if (shouldPrint) {
                     this.printBookingToken(response.data.data.booking_id);
                     this.$router.push({ name: 'consultations' });
                  } else {
                     this.$router.push({ name: 'consultations' });
                  }
               }
            } else {
               this.$swal("", response.data.message, "error");
            }
         },

         handleBookingError(error) {
            if (error.response) {
               if (error.response.data.message) {
                  if (error.response.status == 422) {
                     this.errors = error.response.data.message;
                     this.$nextTick(() => {
                        const firstErrorField = document.querySelector('.is-invalid');
                        if (firstErrorField) {
                           firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                           firstErrorField.focus();
                        }
                     });
                  } else {
                     this.$swal("", error.response.data.message, "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", "Something went wrong", "error");
            }
         },

         addConsultationAutoToken(shouldPrint = false) {
            if (this.scheduleLoading) {
               this.$swal("", "Schedule is still loading. Please wait.", "warning");
               return;
            }

            if (!this.consultation.day_id) {
               this.$swal("", "Schedule data is not available for the selected doctor and date.", "error");
               return;
            }

            const clinicId = this.getClinicIdForBooking();
            if (!clinicId) {
               this.$swal("", "Please select the clinic.", "error");
               return;
            }

            this.prepareConsultationSubmit();

            const config = {
               headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            const payload = {
               day_id: this.consultation.day_id,
               doctor_id: this.consultation.doctor_id,
               patient_id: this.patient_id,
               member_id: this.consultation.consultation_for || null,
               clinic_id: clinicId,
               consultation_type: 3,
               booking_date: this.consultation.booking_date,
               payment_type: this.consultation.payment_type,
               payment_id: this.consultation.payment_id || '',
               amount: this.consultation.amount,
               consultation_fee: this.clinic_fee,
            };

            if (this.external_patient_id && this.external_patient_id.trim()) {
               payload.external_patient_id = this.external_patient_id.trim();
            }

            this.autoTokenLoading = true;

            this.$axios
               .post("api/admin/consultations/addNewAutoToken", payload, config)
               .then((response) => this.handleBookingSuccess(response, shouldPrint))
               .catch((error) => this.handleBookingError(error))
               .finally(() => (this.autoTokenLoading = false));
         },

         setDoctor() {
            this.doctor_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.doctor_visible = false;
            this.fetchSchedules();
         },

         clearSlots() {
            this.consultation.video_slot = '';
            this.consultation.home_slot = '';
            this.consultation.clinic_slot = '';
            
         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         checkDoctor(){

            //if(this.consultation.consultation_through == 2) {

               if (this.doctors.length === 1) {
                     this.consultation.doctor_id = this.doctors[0].id;  
                     this.doctor_keyword = this.doctors[0].name;   
                     console.log('helllkjkj'); 
                     this.fetchClinicSchedule();   
                     this.setDoctor();                                 
               //} 
            }
         
         },

         setCharge() {
            if(this.consultation.consultation_type == 1) {
               this.consultation_fee = this.video_fee;
               this.convenience_fee = this.video_convenience_fee;
               // this.total_amount = parseFloat(this.convenience_fee) + parseFloat(this.video_fee)
               this.total_amount = parseFloat(this.commision) + parseFloat(this.video_fee)
               this.consultation.amount = this.total_amount;
            } else if(this.consultation.consultation_type == 2) {
               this.consultation_fee = this.home_fee;
               this.convenience_fee = this.home_convenience_fee;
               this.total_amount = parseFloat(this.convenience_fee) + parseFloat(this.home_fee)
               this.consultation.amount = this.convenience_fee;
            }
             else if(this.consultation.consultation_type == 3) {
               this.consultation_fee = this.clinic_fee;
               this.convenience_fee = this.clinic_convenience_fee;
               this.total_amount = parseFloat(this.convenience_fee) + parseFloat(this.clinic_fee);
               this.consultation.amount = this.convenience_fee;
            }
             else if(this.consultation.consultation_through == 2) {
               this.consultation_fee = this.clinic_fee;
               this.convenience_fee = this.clinic_convenience_fee;
               this.total_amount = parseFloat(this.convenience_fee) + parseFloat(this.clinic_fee);
               this.consultation.amount = this.convenience_fee;
            }
         },

         
         addConsultation(shouldPrint = false) {
            if(this.patient_visible){
               this.patient_id = '';
            }
            if(this.doctor_visible){
               this.doctor_id = '';
            }
            console.log(this.consultation.video_slot);
            console.log(this.consultation.home_slot);
            console.log('dummy', this.video_schedules);

            let slot = '';  

            if(this.consultation.consultation_type == 1) {
               if(this.consultation.video_slot) {
                  slot = this.consultation.video_slot.split("-"); 
                  this.consultation.day_id = this.video_schedules[0].day_id;
               }

            } else if(this.consultation.consultation_type == 2) {
               if(this.consultation.home_slot) {
                  slot = this.consultation.home_slot.split("-"); 
                  this.consultation.day_id = this.home_schedules[0].day_id;
               }

            } else if(this.consultation.consultation_type == 3 || this.consultation.consultation_through == 2) {
               if(this.consultation.clinic_slot) {
                  this.consultation.consultation_type = 3;
                  slot = this.consultation.clinic_slot.split("-"); 
                  this.consultation.day_id = this.clinic_schedules[0][0].day_id;
               }
            }

            if(slot) {
               this.consultation.start_time = slot[0];
               this.consultation.end_time = slot[1];
               this.consultation.doctor_session_id = slot[2];
               this.consultation.token = slot[3];
               this.consultation.schedule_start = slot[4];
               this.consultation.schedule_end = slot[5];
            }

            console.log(slot);
            console.log(this.consultation.day_id);

            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/consultations/addNew";  
       
            let formData = new FormData();
            formData.append("patient_id", this.patient_id); 
            formData.append("member_id", this.consultation.consultation_for); 
            formData.append("clinic_id", this.consultation.clinic_id); 
            if(this.doctor_keyword != ''){
               formData.append("doctor_id", this.consultation.doctor_id); 
            }
            formData.append("session_id", this.consultation.doctor_session_id); 
            formData.append("consultation_type", this.consultation.consultation_type); 
            formData.append("booking_date", this.consultation.booking_date); 
            formData.append("consultation_start_time", this.consultation.start_time);
            formData.append("consultation_end_time", this.consultation.end_time); 
            formData.append("day_id", this.consultation.day_id); 
            formData.append("token", this.consultation.token); 
            formData.append("schedule_start", this.consultation.schedule_start); 
            formData.append("schedule_end", this.consultation.schedule_end); 

            formData.append("payment_type", this.consultation.payment_type); 
            formData.append("payment_id", this.consultation.payment_id);
            // if(this.consultation.consultation_type == 3) {
            //    formData.append("amount", this.clinic_charge); 
            // }else{
               formData.append("amount", this.consultation.amount); 
               formData.append("consultation_fee", this.consultation_fee); 
            // }
            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     console.log(response);
                     if(response.status == 200){
                        if(shouldPrint){
                           this.printBookingToken(response.data.data.booking_id);
                           this.$router.push({ name: 'consultations'});
                        }else{
                          this.$router.push({ name: 'consultations'}); 
                        }
                     }

                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  //this.clearForm();
                  // this.$router.push({ name: 'consultations'});
               })
               .catch((error) => {
                  console.log(error.response);
                  if (error.response) {
                     if (error.response.data.message) {
                        if(error.response.status == 422) {
                           this.errors = error.response.data.message;
                           if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
      }
   }
</script>

<style type="text/css">
   .slots label.btn {
      border-radius: 5px !important;
      margin-right: 10px;
      margin-bottom: 10px;
   }

   .slots {
      display: inline;
   }

   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }

   .booking-disabled {
      pointer-events: none;
      opacity: 0.65;
   }

   .token-badge {
      display: inline-block;
      background-color: #28a745;
      color: white;
      padding: 3px 12px;
      border-radius: 50px;
      font-size: 12px;
      font-weight: 600;
      margin-left: 8px;
      white-space: nowrap;
      vertical-align: middle;
      line-height: 1;
   }

   .slots label.btn .token-badge {
      background-color: #17a2b8;
   }

   .slots label.btn.active .token-badge {
      background-color: #ffc107;
      color: #000;
   }

   .slots label.btn:disabled .token-badge {
      background-color: #6c757d;
      opacity: 0.6;
   }

   /* Clinic slot token types */
   .slots label.btn .token-badge.token-type-1 {
      background-color: rgba(255, 87, 34, 0.10);  /* Light orange for token_type 1 */
      color: #ff5722;
   }

   .slots label.btn .token-badge.token-type-2 {
      background-color: rgba(139, 195, 74, 0.15);  /* Light green for token_type 2 */
      color: #8bc34a;
   }

   .slots label.btn.active .token-badge.token-type-1 {
      background-color: rgba(255, 87, 34, 0.20);  /* Slightly darker orange when selected */
      color: #ff5722;
   }

   .slots label.btn.active .token-badge.token-type-2 {
      background-color: rgba(139, 195, 74, 0.25);  /* Slightly darker green when selected */
      color: #8bc34a;
   }

   .slots label.btn:disabled .token-badge.token-type-1,
   .slots label.btn:disabled .token-badge.token-type-2 {
      background-color: #6c757d;
      opacity: 0.6;
   }

   /* Color Legend */
   .color-legend {
      display: flex;
      gap: 20px;
      margin-top: 10px;
      padding: 10px 0;
   }

   .legend-item {
      display: flex;
      align-items: center;
      gap: 8px;
   }

   .legend-color {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      display: inline-block;
   }

   .legend-color.green {
      background-color: #ff5722;  /* Orange for In App & TVM */
   }

   .legend-color.red {
      background-color: #8bc34a;  /* Green for TVM */
   }

   .legend-text {
      font-size: 14px;
      font-weight: 500;
      color: #333;
   }
</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                   <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'consultations' }" class="btn btn-primary float-end ms-2">
                           <i class='bx bx-chevrons-left'></i> Back
                           </router-link>

                           <router-link :to="{ name: 'patients.add' }" class="btn btn-primary float-end">
                           Add Patient
                           </router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addConsultation()">
                        
                        <div class="row mb-3">

                           <!-- <div class="form-group col-md-4">
                              <label>Date <span class="text-danger">*</span></label>
                              <input type="date" class="form-control" v-model="consultation.booking_date" @change="fetchSchedules()" v-bind:class="{ 'is-invalid': Boolean(errors.booking_date) }" :min="today" :max="week" />

                              <div v-for="(val, index) in errors.booking_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>    -->

                         <div class="form-group col-md-6" v-click-outside="onClickOutside">
                              <label>Patient <span class="text-danger">*</span></label>
                              <div class="search-select">
                                 <span class="search-close" v-if="patient_visible" @click="closePatientSearch"><i class="dripicons dripicons-cross"></i></span>
                                 <!-- <span class="search-close" v-if="patient_visible && Boolean(patients.length)" @click="closePatientSearch"><i class="dripicons dripicons-cross"></i></span> -->
                                       
                                 <b-form-input ref="patientInput" v-model="patient_keyword"   @keyup="fetchPatients" 
                                 @click="fetchPatients"  autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(errors.patient_id) }"></b-form-input>
                                 
                                 <b-form-select class="form-control" v-if="patient_visible && Boolean(patients.length)" v-model="patient_id" :select-size="patients.length < 10 ? (patients.length <= 1 ? 2 : patients.length) : 10" @change="setPatient">
                                    <b-form-select-option v-for="patient in patients" :key="patient.patient_id" :value="patient.patient_id">{{patient.country_code}} {{patient.mobile}} | {{ patient.name }} </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select class="form-control" v-if="patient_visible && !Boolean(patients.length)" v-model="patient_id" :select-size="2">                  
                                       <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                 </b-form-select>
                              </div>

                              <div v-for="(val, index) in errors.patient_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                        </div>  
                           <div class="form-group col-md-6" >
                              <label>Consultation For <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="consultation.consultation_for" v-bind:class="{ 'is-invalid': Boolean(errors.consultation_for) }" @change="fetchExternalPatientId()">
                                 <option value="">Self</option>
                                 <option :value="member.id" v-for="member in members" :key="member.id">{{member.name}}</option>
                              </select>
                           </div>
                           <div class="form-group col-md-6" v-if="patient_id && consultation.clinic_id">
                              <label>Clinic Patient ID</label>
                              <input
                                 type="text"
                                 class="form-control"
                                 v-model="external_patient_id"
                                 maxlength="100"
                                 placeholder="e.g. UHID-123"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.external_patient_id) }"
                              />
                              <div v-for="(val, index) in errors.external_patient_id" :key="'external_patient_id-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>
                           <div class="form-group col-md-6 d-flex align-items-center">
                              <b-form-radio-group v-model="consultation.consultation_through" @change="clearThrough()">
                                 <div class="form-check-inline">
                                    <b-form-radio name="consultation_through"  value="1">Doctor Booking</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio name="consultation_through" value="2">Clinic Booking</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                           </div> 

                           <div class="form-group col-md-6" v-if="consultation.consultation_through==2">
                              <label>Clinic <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="consultation.clinic_id" v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }" @change="fetchDoctors(); fetchExternalPatientId();">
                                 <option value="">Select</option>
                                 <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">{{clinic.name}}</option>
                              </select>
                           </div>   
                           <div class="form-group col-md-6"   v-if="consultation.consultation_through==1 || consultation.consultation_through==2 && consultation.clinic_id"  :class="{ 'is-invalid': Boolean(errors.doctor_id) }">
                              <label>Doctor <span class="text-danger">*</span></label>
                              <div class="search-select">
                                 <span class="search-close" v-if="doctor_visible" @click="closeDoctorSearch"><i class="dripicons dripicons-cross"></i></span>
                                 <!-- <select class="form-control" v-model="consultation.doctor_id" v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }" @change="clearThrough1(); fetchSchedules()||fetchDoctorDetails()">
                                 <option value="">Select</option>
                                 <option :value="doctor.id" v-for="doctor in doctors" :key="doctor.id">{{doctor.country_code}} {{doctor.mobile}} | {{doctor.prefix}} {{ doctor.name }}</option>
                              </select>      -->
                                 <b-form-input v-model="doctor_keyword"  ref="doctorInput" @keyup="fetchDoctors()"  @click="fetchDoctors()" autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }"></b-form-input>
                                 
                                 <b-form-select class="form-control" v-if="doctor_visible && doctors.length > 1" v-model="consultation.doctor_id" :select-size="doctors.length < 10 ? (doctors.length <= 1 ? 2 : doctors.length) : 10" @change="setDoctor(); fetchSchedules()||fetchDoctorDetails()">
                                    <b-form-select-option v-for="doctor in doctors" :key="doctor.id" :value="doctor.id">{{doctor.country_code}} {{doctor.mobile}} | {{doctor.prefix}} {{ doctor.name }} </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select class="form-control" v-if="doctor_visible && !Boolean(doctors.length)" v-model="doctor_id" :select-size="2">                  
                                       <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                 </b-form-select>
                              </div>

                              <!-- <div v-for="(val, index) in errors.doctor_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div> -->
                              <div v-if="errors.doctor_id" class="invalid-feedback" style="color: red; display: block;">
                                 <div v-for="(error, index) in errors.doctor_id" :key="index">
                                    <p class="mb-0">{{ error }}</p>
                                 </div>
                              </div>
                           </div>
                            <div class="form-group col-md-6" v-if="consultation.doctor_id">
                              <label>Date <span class="text-danger">*</span></label>
                              <input type="date" class="form-control" v-model="consultation.booking_date" @change="fetchSchedules()" v-bind:class="{ 'is-invalid': Boolean(errors.booking_date) }" :min="today"/>

                              <div v-for="(val, index) in errors.booking_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>   
                           <!-- <div class="form-group col-md-6"  v-click-outside="onClickOutside" v-if="consultation.consultation_through==2 && consultation.clinic_id">
                              <label>Doctor <span class="text-danger">*</span></label>
                              <div class="search-select">
                                       
                                 <b-form-input ref="doctorInput" v-model="doctor_keyword"  @keyup="fetchclinicDoctors()" @click="fetchclinicDoctors()" autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }"></b-form-input>
                                 
                                 <b-form-select class="form-control" v-if="doctor_visible && Boolean(doctors.length)" v-model="doctor_id" :select-size="doctors.length < 10 ? (doctors.length <= 1 ? 2 : doctors.length) : 10" @change="setDoctor">
                                    <b-form-select-option v-for="doctor in doctors" :key="doctor.id" :value="doctor.id">{{doctor.country_code}} {{doctor.mobile}} | Dr. {{ doctor.name }} </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select class="form-control" v-if="doctor_visible && !Boolean(doctors.length)" v-model="doctor_id" :select-size="2">                  
                                       <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                 </b-form-select>
                              </div>

                              <div v-for="(val, index) in errors.doctor_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div> -->
                        </div>

                        <b-card  header-class="bg-transparent border-light" class="border border-light"  v-if="consultation.doctor_id && consultation.booking_date">
                           <!-- <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                              Consultation Type                        
                              
                           </h4> -->

                           <b-form-radio-group  v-if="consultation.consultation_through==1"
                                 v-model="consultation.consultation_type"
                                 name="consultation_type"
                                 @change="clearSlots(), setCharge()"
                              > 
                              <label>Consultation Type  <span class="text-danger">*</span></label>      
       
                              <div class="row">
                                 <div class="form-group col-md-4">                        
                                    <b-form-radio value="1">Video Consultation</b-form-radio>  
                                 </div>   
                                 <div class="form-group col-md-4">                        
                                    <b-form-radio value="2">Home Consultation</b-form-radio> 
                                 </div>   
                                 <div class="form-group col-md-4">                        
                                    <b-form-radio value="3">Clinic Consultation</b-form-radio>   
                                 </div>                        
                              </div>
                           </b-form-radio-group>

                           <div class="row">
                              <div class="form-group col-md-4">                        
                                       <label class="text-success"><b>Consultation Fee : {{ this.consultation_fee }}</b></label>   
                              </div>  

                              <div class="form-group col-md-4" v-if="consultation.consultation_type==1">                        
                                       <label class="text-success"><b>Platform Fee : ₹ {{ this.convenience_fee }}</b></label>   
                              </div> 

                              <div class="form-group col-md-4" v-if="consultation.consultation_type==2">                        
                                       <label class="text-success"><b>Convenience Fee : ₹ {{ this.convenience_fee }}</b></label>   
                              </div> 

                              <div class="form-group col-md-4" v-if="consultation.consultation_type==3 || consultation.consultation_through==2">                        
                                       <label class="text-success"><b>Convenience Fee : ₹ {{ this.convenience_fee }}</b></label>   
                              </div> 

                              <div class="form-group col-md-4">                        
                                       <label class="text-danger bg" style="font-size: 15px;"><b>Total Fee :  ₹ {{ this.total_amount }}</b></label>   
                              </div> 

                           </div>

                           <div v-if="patient_id && consultation.doctor_id && consultation.booking_date" class="border border-light rounded p-3 mb-3">
                              <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                                 Payment Details
                              </h4>

                              <div class="row">
                                 <div class="form-group col-md-4" v-bind:class="{ 'is-invalid': Boolean(errors.payment_type) }">
                                    <label>Payment Type <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="consultation.payment_type">
                                          <option value="Cash">Cash</option>
                                          <option value="Card">Card</option>
                                          <option value="Internet Banking">Internet Banking</option>
                                          <option value="GPay">GPay</option>
                                          <option value="Other UPI">Other UPI</option>
                                    </select>

                                    <div v-for="(val, index) in errors.payment_type" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </div>

                                 <div class="form-group col-md-4" v-bind:class="{ 'is-invalid': Boolean(errors.payment_id) }">
                                    <label>Payment ID <span v-if="consultation.payment_type!='Cash'" class="text-danger">*</span></label>
                                    <input type="text" v-model="consultation.payment_id" class="form-control"/>

                                    <div v-for="(val, index) in errors.payment_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </div>

                                 <div class="form-group col-md-4" v-if="consultation.payment_type" :class="{ 'is-invalid': Boolean(errors.amount) }">
                                    <label>Amount <span class="text-danger">*</span></label>
                                    <b-input-group size="sm" prepend="Rs.">
                                       <input type="text" v-model="total_amount" @keypress="numbersOnly" class="form-control" />

                                       <div v-for="(val, index) in errors.amount" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </b-input-group>
                                 </div>
                              </div>
                           </div>

                           <!-- Color Legend for Clinic Slots -->
                           <div class="row" v-if="consultation.consultation_type==3 || consultation.consultation_through==2">
                              <div class="col-12">
                                 <div class="color-legend">
                                    <span class="legend-item">
                                       <span class="legend-color green"></span>
                                       <span class="legend-text">Patient App & Token Vending Machine</span>
                                    </span>
                                    <span class="legend-item">
                                       <span class="legend-color red"></span>
                                       <span class="legend-text">Token Vending Machine</span>
                                    </span>
                                 </div>
                              </div>
                           </div>

                           <div class="row">
                              <div class="col-12">
                                 <div v-if="consultation.consultation_type==1">
                                    <div v-if="video_slots.length">
                                       <label class="w-100">Pick your slot <span class="text-danger">*</span></label>
                                       <b-form-radio-group 
                                          v-model="consultation.video_slot"
                                          name="video_slot"
                                          buttons
                                          button-variant="outline-primary"
                                          size="sm"
                                          class="slots"
                                       > 
                                        
                                          <b-form-radio  v-for="(slot, index) in video_slots" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end "  :disabled="!slot.slot_available || slot.dnone" >{{slot.start | formatTime}} - {{slot.stop | formatTime}} <span class="token-badge">{{slot.token}}</span></b-form-radio>
                                           
                                       </b-form-radio-group>
                                       
                                    </div>
                                    <div v-else-if="video_on_leave">
                                       <p class="text-danger">Doctor is on leave</p>
                                    </div>
                                    <div v-else>
                                       <p class="text-danger">No available slots</p>
                                    </div>
                                    <div v-for="(val, index) in errors.session_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>  
                                 </div>
                                 <!-- <div v-if="consultation.consultation_type==1">
                                    <p>Coming Soon</p>
                                 </div> -->

                                 <div v-if="consultation.consultation_type==2">
                                    <div v-if="home_slots.length" v-bind:class="{ 'is-invalid': Boolean(errors.session_id) }">
                                       <label class="w-100">Pick your slot <span class="text-danger">*</span></label>
                                       <b-form-radio-group 
                                          v-model="consultation.home_slot"
                                          name="home_slot"
                                          buttons
                                          button-variant="outline-primary"
                                          size="sm"
                                          class="slots"
                                       >  
                                          <b-form-radio v-for="(slot, index) in home_slots" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end "  :disabled="!slot.slot_available || slot.dnone" >{{slot.start | formatTime}} - {{slot.stop | formatTime}} <span class="token-badge">{{slot.token}}</span></b-form-radio>  
                                       </b-form-radio-group>
                                    </div>
                                    <div v-else-if="home_on_leave">
                                       <p class="text-danger">Doctor is on leave</p>
                                    </div>
                                    <div v-else>
                                       <p class="text-danger">No available slots</p>
                                    </div>
                                    <div v-for="(val, index) in errors.session_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>  
                                 </div>

                                 <div v-if="consultation.consultation_type==3 || consultation.consultation_through==2">
                                    <div class="form-group col-md-6" v-if="consultation.consultation_through==1">
                                       <label>Clinic <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="consultation.clinic_id" v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }" @change="fetchClinicSchedule(); fetchExternalPatientId();" >
                                          <option value="">Select</option>
                                          <option :value="clinic.clinic_id" v-for="clinic in clinics" :key="clinic.clinic_id">{{clinic.clinic_name}}</option>
                                       </select>
                                    </div>

                                    <div class="row mb-3" v-if="patient_id && showClinicPaymentDetails">
                                       <div class="col-12">
                                          <p class="text-muted mb-2" v-if="scheduleLoading">
                                             <i class="bx bx-loader-alt bx-spin"></i>
                                             Loading schedule...
                                          </p>
                                          <p class="text-muted mb-2" v-else-if="!autoTokenLoading">
                                             <i class="bx bx-info-circle"></i>
                                             Book the next available token automatically, or pick a slot manually below.
                                          </p>
                                          <div v-if="autoTokenLoading" class="page-loader mb-2">
                                             <img src="@/assets/images/preloaderspin.gif" alt="Booking..." />
                                          </div>
                                          <template v-else>
                                             <button
                                                class="btn btn-success me-2 mb-2"
                                                type="button"
                                                @click.prevent="addConsultationAutoToken(true)"
                                                :disabled="scheduleLoading || isBookingInProgress || !consultation.day_id"
                                             >
                                                Book Next Available — Save &amp; Print
                                             </button>
                                             <button
                                                class="btn btn-success me-2 mb-2"
                                                type="button"
                                                @click.prevent="addConsultationAutoToken(false)"
                                                :disabled="scheduleLoading || isBookingInProgress || !consultation.day_id"
                                             >
                                                Book Next Available — Save
                                             </button>
                                          </template>
                                       </div>
                                    </div>

                                    <div class="w-100" :class="{ 'booking-disabled': isBookingInProgress }">     
                                          <div v-if="clinic_slots.length" v-bind:class="{ 'is-invalid': Boolean(errors.session_id) }">
                                             <label class="w-100">Pick your slot <span class="text-danger">*</span></label>
                                             <b-form-radio-group 
                                                v-model="consultation.clinic_slot"
                                                name="clinic_slot"
                                                buttons
                                                button-variant="outline-primary"
                                                size="sm"
                                                class="slots"
                                                :disabled="isBookingInProgress"
                                             >  
                                                <b-form-radio v-for="(slot, index) in clinic_slots" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end + '-'  "  :disabled="!slot.slot_available || slot.dnone || isBookingInProgress">{{slot.start | formatTime}} - {{slot.stop | formatTime}} <span class="token-badge" :class="{'token-type-1': slot.token_type == 1, 'token-type-2': slot.token_type == 2}">{{slot.token}}</span></b-form-radio>  
                                                </b-form-radio-group>
                                          </div>
                                          <div v-else-if="clinic_on_leave">
                                             <p class="text-danger">Doctor is on leave</p>
                                          </div>
                                          <div v-else>
                                             <p class="text-danger">No available slots</p>
                                          </div>
                                          <div v-for="(val, index) in errors.session_id" :key="index" class="invalid-feedback">
                                             <p class="mb-0">{{ val }}</p>
                                          </div>  
                                    </div>
                                 </div>

                                 
                              </div>
                           </div>
                        </b-card>

                        <div class="row mt-3">
                           <div class="col-12">
                              <!-- <button class="btn btn-primary me-2" type="submit" v-if="consultation.consultation_type!=1">Save</button> -->
                              <div v-if="isBookingInProgress" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" @click.prevent="addConsultation(true)">Save & Print</button>
                                 <button class="btn btn-primary me-2" @click.prevent="addConsultation(false)">Save</button>
                                 <router-link :to="{ name: 'consultations' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
